var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOmnigenWhiteOnly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 417.94 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.73,76.52c-3.77,0-7.28-.63-10.52-1.89-3.24-1.26-6.04-3.03-8.42-5.31-2.38-2.28-4.22-4.95-5.52-8-1.3-3.05-1.96-6.37-1.96-9.96s.65-6.98,1.96-10.03c1.3-3.05,3.14-5.71,5.52-7.97,2.38-2.26,5.17-4.02,8.39-5.28s6.73-1.89,10.55-1.89,7.27,.62,10.48,1.85c3.21,1.23,6,2.98,8.35,5.24,2.35,2.26,4.18,4.93,5.49,8,1.3,3.07,1.96,6.43,1.96,10.06s-.65,6.98-1.96,10.03c-1.3,3.05-3.13,5.72-5.49,8-2.35,2.28-5.14,4.04-8.35,5.28-3.21,1.23-6.71,1.85-10.48,1.85Zm0-7.97c2.47,0,4.74-.42,6.81-1.26,2.07-.84,3.88-2.03,5.42-3.56,1.54-1.54,2.74-3.35,3.6-5.45,.86-2.1,1.29-4.4,1.29-6.92s-.42-4.82-1.26-6.92c-.84-2.1-2.04-3.91-3.6-5.45-1.56-1.54-3.38-2.72-5.45-3.56-2.07-.84-4.34-1.26-6.81-1.26s-4.76,.42-6.88,1.26c-2.12,.84-3.95,2.04-5.49,3.6-1.54,1.56-2.75,3.38-3.63,5.45-.89,2.07-1.33,4.37-1.33,6.88s.44,4.75,1.33,6.85c.88,2.1,2.1,3.92,3.63,5.49,1.54,1.56,3.36,2.76,5.49,3.6,2.12,.84,4.41,1.26,6.88,1.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,38.02c2.98,0,5.62,.58,7.93,1.75,2.31,1.17,4.11,2.96,5.42,5.38,1.3,2.42,1.96,5.52,1.96,9.29v21.38h-8.67v-20.27c0-3.31-.73-5.78-2.2-7.41-1.47-1.63-3.55-2.45-6.25-2.45-1.91,0-3.6,.42-5.07,1.26-1.47,.84-2.61,2.08-3.42,3.74-.82,1.65-1.22,3.72-1.22,6.18v18.94h-8.67v-20.27c0-3.31-.73-5.78-2.2-7.41-1.47-1.63-3.55-2.45-6.25-2.45-1.91,0-3.6,.42-5.07,1.26s-2.61,2.08-3.42,3.74c-.82,1.65-1.22,3.72-1.22,6.18v18.94h-8.67V38.51h8.32v9.99l-1.54-3c1.26-2.38,3.09-4.22,5.49-5.52,2.4-1.3,5.16-1.96,8.28-1.96,3.49,0,6.52,.86,9.08,2.58,2.56,1.72,4.26,4.38,5.1,7.97l-3.35-1.26c1.16-2.75,3.14-4.98,5.94-6.71,2.79-1.72,6.03-2.58,9.71-2.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.98,38.02c3.03,0,5.7,.58,8,1.75,2.31,1.17,4.15,2.96,5.52,5.38,1.37,2.42,2.06,5.52,2.06,9.29v21.38h-8.73v-20.27c0-3.31-.77-5.78-2.31-7.41-1.54-1.63-3.73-2.45-6.57-2.45-2.05,0-3.87,.42-5.45,1.26s-2.81,2.08-3.67,3.74c-.86,1.65-1.29,3.74-1.29,6.25v18.87h-8.67V38.51h8.32v10.13l-1.47-3.14c1.26-2.38,3.13-4.22,5.63-5.52,2.49-1.3,5.37-1.96,8.63-1.96Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.79,32.36c-1.63,0-2.97-.51-4.02-1.54-1.05-1.02-1.57-2.28-1.57-3.77,0-1.4,.52-2.61,1.57-3.63,1.05-1.02,2.39-1.54,4.02-1.54s2.97,.48,4.02,1.43c1.05,.96,1.57,2.18,1.57,3.67s-.51,2.76-1.54,3.81c-1.03,1.05-2.38,1.57-4.05,1.57Zm-4.33,43.46V38.51h8.67v37.32h-8.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.09,74.14c-3.59,0-6.8-.76-9.64-2.27-2.84-1.51-5.09-3.62-6.74-6.32-1.65-2.7-2.48-5.85-2.48-9.43s.83-6.81,2.48-9.54c1.65-2.72,3.9-4.83,6.74-6.32,2.84-1.49,6.06-2.24,9.64-2.24,3.17,0,6.02,.64,8.56,1.92,2.54,1.28,4.55,3.25,6.04,5.91s2.24,6.08,2.24,10.27-.75,7.48-2.24,10.13c-1.49,2.66-3.51,4.64-6.04,5.94-2.54,1.3-5.39,1.96-8.56,1.96Zm1.12,15.72c-3.49,0-6.86-.46-10.1-1.36-3.24-.91-5.93-2.25-8.07-4.02l3.91-6.5c1.63,1.35,3.68,2.45,6.15,3.28,2.47,.84,5.03,1.26,7.69,1.26,4.05,0,7.03-.94,8.94-2.83,1.91-1.89,2.87-4.74,2.87-8.56v-6.64l.7-8.39-.28-8.46v-9.15h8.32v31.66c0,6.75-1.72,11.73-5.17,14.92-3.45,3.19-8.43,4.79-14.95,4.79Zm.21-23.13c2.19,0,4.15-.45,5.87-1.36s3.06-2.17,4.02-3.77c.95-1.61,1.43-3.43,1.43-5.49s-.48-4.01-1.43-5.59c-.96-1.58-2.29-2.82-4.02-3.7-1.72-.88-3.68-1.33-5.87-1.33s-4.16,.44-5.91,1.33c-1.75,.89-3.1,2.12-4.05,3.7-.96,1.58-1.43,3.45-1.43,5.59s.48,3.88,1.43,5.49c.95,1.61,2.31,2.87,4.05,3.77s3.71,1.36,5.91,1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.04,76.31c-4.15,0-7.77-.83-10.87-2.48-3.1-1.65-5.5-3.91-7.2-6.78-1.7-2.86-2.55-6.16-2.55-9.89s.83-7.02,2.48-9.89c1.65-2.87,3.94-5.12,6.85-6.78,2.91-1.65,6.23-2.48,9.96-2.48s6.87,.8,9.71,2.41c2.84,1.61,5.08,3.86,6.71,6.74,1.63,2.89,2.45,6.31,2.45,10.27,0,.33-.01,.73-.04,1.22s-.06,.92-.1,1.29h-31.1v-5.8h26.48l-3.49,1.82c.05-2.1-.38-3.97-1.29-5.63-.91-1.65-2.16-2.93-3.74-3.84-1.58-.91-3.45-1.36-5.59-1.36s-3.97,.46-5.63,1.36-2.92,2.2-3.81,3.88c-.89,1.68-1.33,3.61-1.33,5.8v1.4c0,2.24,.5,4.22,1.5,5.94,1,1.72,2.43,3.06,4.3,4.02,1.86,.96,4.03,1.43,6.5,1.43,2.1,0,3.98-.35,5.66-1.05,1.68-.7,3.17-1.72,4.47-3.08l4.75,5.45c-1.72,1.96-3.86,3.45-6.39,4.47-2.54,1.03-5.44,1.54-8.7,1.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.85,38.02c3.03,0,5.7,.58,8,1.75,2.31,1.17,4.15,2.96,5.52,5.38,1.37,2.42,2.06,5.52,2.06,9.29v21.38h-8.73v-20.27c0-3.31-.77-5.78-2.31-7.41-1.54-1.63-3.73-2.45-6.57-2.45-2.05,0-3.87,.42-5.45,1.26-1.58,.84-2.81,2.08-3.67,3.74-.86,1.65-1.29,3.74-1.29,6.25v18.87h-8.67V38.51h8.32v10.13l-1.47-3.14c1.26-2.38,3.13-4.22,5.62-5.52,2.49-1.3,5.37-1.96,8.63-1.96Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.5,98.27v6.73c9.2-.01,18.28-2.44,26.25-7.03l-3.37-5.83c-6.95,4.01-14.86,6.12-22.89,6.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.61,92.14l-3.37,5.83c8.29,4.78,17.33,7.04,26.25,7.03v-6.73c-7.78,.01-15.66-1.95-22.89-6.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.38,92.14l3.37,5.83c7.73-4.45,14.44-10.93,19.22-19.21l-5.83-3.37c-4.17,7.22-10.02,12.87-16.76,16.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.27,52.5c.01,7.78-1.95,15.66-6.12,22.89l5.83,3.37c4.78-8.29,7.04-17.33,7.03-26.25h-6.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.27,52.5h6.73c-.01-9.2-2.44-18.28-7.03-26.25l-5.83,3.37c4.01,6.95,6.12,14.86,6.13,22.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73,52.5H0c.01,9.2,2.44,18.28,7.03,26.25l5.83-3.37c-4.01-6.95-6.12-14.86-6.13-22.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.86,29.61l-5.83-3.37C2.24,34.53-.01,43.57,0,52.5H6.73c-.01-7.78,1.95-15.66,6.12-22.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,6.73V0c-9.2,.01-18.28,2.44-26.25,7.03l3.37,5.83c6.95-4.01,14.86-6.12,22.89-6.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.39,12.85l3.37-5.83C70.47,2.24,61.42-.01,52.5,0V6.73c7.78-.01,15.66,1.95,22.89,6.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.61,12.86l-3.37-5.83c-7.73,4.45-14.44,10.93-19.22,19.21l5.83,3.37c4.17-7.22,10.02-12.87,16.76-16.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.37,16.35l-3.37,5.83c5.52,3.19,9.84,7.66,12.81,12.81l5.83-3.37c-3.54-6.15-8.69-11.48-15.27-15.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,82.81l3.37,5.83c6.15-3.54,11.48-8.69,15.28-15.27l-5.83-3.37c-3.19,5.52-7.66,9.84-12.81,12.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,87.5v6.73c7.31-.01,14.53-1.94,20.87-5.59l-3.37-5.83c-5.32,3.06-11.37,4.68-17.5,4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.81,70l5.83,3.37c3.8-6.59,5.59-13.78,5.58-20.87h-6.73c0,5.95-1.49,11.98-4.68,17.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5,52.5h6.73c0-7.31-1.94-14.53-5.59-20.87l-5.83,3.37c3.06,5.32,4.68,11.37,4.69,17.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.19,70l-5.83,3.37c3.54,6.15,8.69,11.48,15.27,15.28l3.37-5.83c-5.52-3.19-9.84-7.66-12.81-12.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,52.5h-6.73c.01,7.31,1.94,14.53,5.59,20.87l5.83-3.37c-3.06-5.32-4.68-11.37-4.69-17.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.18,35l-5.83-3.37c-3.8,6.59-5.59,13.78-5.58,20.87h6.73c0-5.95,1.49-11.98,4.68-17.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,17.5v-6.73c-7.31,.01-14.53,1.94-20.87,5.59l3.37,5.83c5.32-3.06,11.37-4.68,17.5-4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,22.19l-3.37-5.83c-6.15,3.54-11.48,8.69-15.28,15.27l5.83,3.37c3.19-5.52,7.66-9.84,12.81-12.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.38,73.49l-3.37,5.83c4.89,2.82,10.22,4.15,15.48,4.14v-6.74c-4.12,0-8.29-1.03-12.12-3.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.61,73.47l3.37,5.84c4.56-2.63,8.52-6.45,11.34-11.33l-5.83-3.37c-2.21,3.82-5.31,6.8-8.88,8.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.49,64.62l5.83,3.37c2.82-4.89,4.15-10.22,4.14-15.48h-6.74c0,4.12-1.03,8.29-3.24,12.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.72,52.5h6.74c0-5.43-1.44-10.78-4.15-15.48l-5.84,3.37c2.12,3.68,3.24,7.86,3.25,12.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.47,40.39l5.84-3.37c-2.63-4.56-6.45-8.52-11.33-11.34l-3.37,5.83c3.82,2.21,6.8,5.31,8.85,8.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.53,64.61l-5.84,3.37c2.63,4.56,6.45,8.52,11.33,11.34l3.37-5.83c-3.82-2.21-6.8-5.31-8.85-8.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.51,40.38l-5.83-3.37c-2.82,4.89-4.15,10.22-4.14,15.48h6.74c0-4.12,1.03-8.29,3.24-12.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.62,31.51l3.37-5.83c-4.89-2.82-10.22-4.15-15.48-4.14v6.74c4.12,0,8.29,1.03,12.12,3.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.39,31.53l-3.37-5.84c-4.56,2.63-8.52,6.45-11.34,11.33l5.83,3.37c2.21-3.82,5.31-6.8,8.88-8.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.28,52.5h-6.74c0,5.43,1.44,10.78,4.15,15.48l5.84-3.37c-2.12-3.68-3.24-7.86-3.25-12.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.15,45.77l5.83-3.36c-1.71-2.97-4.19-5.56-7.38-7.4l-3.37,5.83c2.12,1.23,3.78,2.95,4.92,4.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.95,52.5h6.73c0-3.54-.94-7.02-2.71-10.09l-5.83,3.36c1.18,2.04,1.8,4.37,1.8,6.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.16,59.23l5.83,3.37c1.84-3.19,2.7-6.67,2.7-10.1h-6.73c0,2.29-.57,4.61-1.79,6.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,65.95v6.73c3.54,0,7.02-.94,10.09-2.71l-3.36-5.83c-2.04,1.18-4.37,1.8-6.73,1.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.77,64.16l-3.37,5.83c3.19,1.84,6.67,2.7,10.1,2.7v-6.73c-2.29,0-4.61-.57-6.73-1.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.85,59.22l-5.83,3.36c1.71,2.97,4.19,5.56,7.38,7.4l3.37-5.83c-2.12-1.23-3.78-2.95-4.92-4.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.23,40.84l3.37-5.83c-3.19-1.84-6.67-2.7-10.1-2.7v6.73c2.29,0,4.61,.57,6.73,1.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,39.04v-6.73c-3.54,0-7.02,.94-10.09,2.71l3.36,5.83c2.04-1.18,4.37-1.8,6.73-1.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.04,52.5c0-2.29,.57-4.61,1.79-6.73l-5.83-3.37c-1.84,3.19-2.7,6.67-2.7,10.1h6.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.04,52.5h-6.73c0,3.54,.94,7.02,2.71,10.09l5.83-3.36c-1.18-2.04-1.8-4.37-1.8-6.73Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmnigenWhiteOnly);
export default __webpack_public_path__ + "static/media/OmnigenWhiteOnly.fac4e9830dbfa12b01613e09ec065428.svg";
export { ForwardRef as ReactComponent };